import { hashKey, useQuery } from '@tanstack/react-query';
import _ from 'lodash';

import { GoodLocation, GoodLocationCriteria, GoodsLocationQualifierIdentification, SortDirection } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

export const defaultGoodLocationCriteria: GoodLocationCriteria = {
  filters: { searchQuery: '' },
  pagination: { page: 1, size: 10 },
  sorting: { field: 'updatedAt', direction: SortDirection.DESC },
};

export const useGoodLocation = (declarantId?: string, criteria?: GoodLocationCriteria) =>
  useQuery({
    queryKey: ['good-locations', declarantId, ...(criteria ? [hashKey([criteria])] : [])],
    queryFn: async (): Promise<{ data: GoodLocation[]; totalItems: number }> => {
      try {
        const { data } = await request({
          path: `declarant/${declarantId}/goods-locations`,
          method: 'POST',
          authenticate: true,
          dataObject: criteria ? { criteria } : undefined,
        });
        const locations = (data?.goodsLocations || []).map((location: any) => {
          let city = 'N/A';
          if (location.address?.city) {
            city = location.address.city;
          }
          let postcode = 'N/A';
          if (location.qualifierOfIdentification === GoodsLocationQualifierIdentification.POSTCODE_ADDRESS && location.postcode?.postcode) {
            postcode = location.postcode.postcode;
          } else if (location.qualifierOfIdentification === GoodsLocationQualifierIdentification.ADDRESS && location.address?.postcode) {
            postcode = location.address.postcode;
          }
          return { ...location, virtuals: { displayedCity: city, displayedPostcode: postcode } };
        });

        return {
          data: locations,
          totalItems: data.totalItems || 0,
        };
      } catch (error) {
        showErrorToast(error, 'Error fetching the goods locations!');
        return {
          data: [],
          totalItems: 0,
        };
      }
    },
    enabled: !!declarantId,
    placeholderData: { data: [], totalItems: 0 },
  });
